<div class="containerList">

    <div class="order">

      <mat-card class="card-simple-shadow"  >

          <mat-card-header>
              <mat-card-title [ngClass]="orderStatus.isDelivered ? 'text-sucess' : (orderStatus.isNotDelivered ? 'text-danger' : 'text-blue-puppis')"> {{ orderStatus.statusName }} </mat-card-title>
              <mat-card-subtitle class="subtitle-main"> Compraste en : {{ orderStatus.source }} </mat-card-subtitle> 
              <mat-card-subtitle *ngIf="order?.sourceCode"> Orden: {{ order?.sourceCode }} </mat-card-subtitle>
          </mat-card-header>
  
      </mat-card>

      <ng-container *ngIf="order?.deliveryData && orderStatus?.isDelivered">

        <mat-card class="card-separator-line" >
          <mat-card-title> Domicilio de Entrega </mat-card-title>
        </mat-card>

        <mat-card class="card-simple-shadow" >

          <mat-card-content>
            
            <div class="card-order-content">
              <div class="card-order-content-left">
                <mat-icon class="icon-scale-1-5" color="accent">home</mat-icon>
              </div>
              <div class="card-order-content-right">
                <mat-card-title> {{ order?.deliveryData?.street }} {{ order?.deliveryData?.number }} </mat-card-title>
                <mat-card-subtitle style="margin-bottom: 2px;">{{ order?.deliveryData?.city }} , {{ order?.deliveryData?.state }} </mat-card-subtitle>
              </div>
            </div>

          </mat-card-content>

        </mat-card>

      </ng-container>
      

      <mat-card class="card-separator-line">
        <mat-card-title> Detalle de la orden </mat-card-title>
      </mat-card>


      <mat-card class="card-simple-shadow" >

        <mat-card-content >

          <div class="card-order-item" *ngFor="let oi of order?.orderItems">

            <div class="card-order-item-content">

              <div class="card-order-item-content-left">
                <img mat-card-sm-image [src]="oi.imageUrl || getImageDefault()" (error)="loadErrorImage($event)">
              </div>

              <div class="card-order-item-content-center">
                <mat-card-title>{{ oi.description }}</mat-card-title>
                <!-- <mat-card-subtitle> Cód. SKU: {{ oi.sku }} </mat-card-subtitle> -->
              </div>

              <div class="card-order-item-content-right" >
                  <mat-card-subtitle> ${{ oi.grossAmount }} </mat-card-subtitle>
              </div>

            </div>

            <div class="card-order-item-content-footer" >
              <mat-card-title> x {{ oi.quantity }} unidades ${{getTotalItem(oi)}} </mat-card-title>
            </div>
          </div>

        </mat-card-content>
        <mat-card-content>
           
          <div class="card-order-resume card-bottom-border">
            <mat-card-title>Descuento</mat-card-title>  <mat-card-title>${{ getDiscountOrder() }} </mat-card-title> 
          </div>

          <div class="card-order-resume">
            <mat-card-title>Total</mat-card-title>  <mat-card-title>${{order?.netAmount }} </mat-card-title> 
          </div>

        </mat-card-content>
       
    </mat-card>


    </div>

    


</div>



<loading-indicator *ngIf="isLoading"></loading-indicator>